document.addEventListener("DOMContentLoaded", function () {
    gsap.set('.co-os-s3-frame .z-ani-o', { opacity: 0, y: 40 });
    let cOsS3Tl1 = gsap.timeline({ paused: true });
    cOsS3Tl1.to('.co-os-s3-frame .z-ani-o', {
        y: 0,
        scale: 1,
        opacity: 1,
        duration: 1,
        stagger: 0.2,
        ease: "power2.inOut"
    }, "-=0.9");
    ScrollTrigger.create({
        trigger: '.co-os-s3-frame .z-ani-o',
        start: "40% bottom",
        end: "bottom top",
        animation: cOsS3Tl1
    });

    //Simple Accordion
    var coAccItems = document.querySelectorAll(".co-os-s3-item--title");
    var coAccItemsWrapp = document.querySelectorAll(".co-os-s3-item");
    // console.log(coAccItems);
    // coAccItems.slice(0, 3).classList.add('visible');
    // Hide the next sibling element for each item (the content associated with the title)
    coAccItems.forEach(function (groupItem, index) {
        var nextElement = groupItem.nextElementSibling;
        if (index === 0 || groupItem.classList.contains("active")) {
            groupItem.classList.add("active");
            nextElement.classList.add("active");

            gsap.to(nextElement, {
                height: "auto",
                duration: 0.3,
                ease: "power2.inOut",
            });
        } else {
            nextElement.classList.remove("active");
            gsap.to(nextElement, {
                height: 0,
                duration: 0.3,
                ease: "power2.inOut",
            });
        }

        // Add a click event listener to each item
        groupItem.addEventListener("click", function (e) {
            e.preventDefault();
            // Check if the parent element already has the 'active' class
            if (!this.classList.contains("active")) {
                // If not active, hide all other sections
                // coAccItems.forEach(function (otherAccItem, otherIndex) {
                //   otherAccItem.classList.remove("active");
                //   otherAccItem.nextElementSibling.classList.remove("active");

                //   gsap.to(otherAccItem.nextElementSibling, {
                //     height: 0,
                //     duration: 0.3,
                //     ease: "power2.inOut",
                //   });
                // });
                // Add 'active' class to the clicked item and show its content
                this.classList.add("active");
                nextElement.classList.add("active");
                gsap.to(nextElement, {
                    height: "auto",
                    duration: 0.3,
                    ease: "power2.inOut",
                });
            } else {
                // remove 'active' if clicked on 'active'
                this.classList.remove("active");
                nextElement.classList.remove("active");
                gsap.to(nextElement, {
                    height: 0,
                    duration: 0.3,
                    ease: "power2.inOut",
                });
            }
            // If already active, don't hide the content
        });


    });

    // coAccItemsWrapp.forEach(function (item, index) {
    //     if (index >= 6) {
    //         item.classList.add('hidden');
    //     }
    // });
});